import React from 'react';
import r2wc from '@r2wc/react-to-web-component';
// @ts-ignore next
import { ListingCarouselEmbedded } from '@adc/ui-adc';
import { getWebComponentName } from '../utils';
import '../types';
import { useGeoLocation } from '../hooks/useGeoLocation';
import { useUserAndFlags } from '../hooks/useUserAndFlags';
import { showcaseListingsFlag } from '../constants';
const getShowcaseListings = (featureFlags, listingShowcaseKey) => {
    let showcaseListings = null;
    const showcaseListingsFlagValue = featureFlags?.[showcaseListingsFlag];
    if (showcaseListingsFlagValue) {
        showcaseListings = showcaseListingsFlagValue[listingShowcaseKey];
    }
    if (!showcaseListings) {
        throw new Error(`Invalid listingShowcaseKey: ${listingShowcaseKey}`);
    }
    return showcaseListings;
};
const WrappedComponent = ({ queryType, listingShowcaseKey, }) => {
    const geo = useGeoLocation();
    const { featureFlags } = useUserAndFlags();
    try {
        let showcaseListings = null;
        if (listingShowcaseKey) {
            showcaseListings = getShowcaseListings(featureFlags, listingShowcaseKey);
        }
        else if (!queryType) {
            throw new Error('queryType or listingShowcaseKey is required');
        }
        return (React.createElement(ListingCarouselEmbedded, { queryType: queryType, showcaseListings: showcaseListings, featureFlags: featureFlags, coordinates: geo.coordinates, elmId: 'dk_listing_carousel', targetHost: window?.CONFIGS?.AUCTIONCOM_HOST }));
    }
    catch (e) {
        if (e instanceof Error) {
            console.warn(e.toString());
        }
        else {
            console.warn(String(e));
        }
        return (
        // fail gracefully
        React.createElement("div", { style: { fontSize: '16px', color: '#97a0a6', textAlign: 'center' } }, "Featured listings coming soon..."));
    }
};
const WebButton = r2wc(WrappedComponent, {
    props: {
        queryType: 'string',
        listingShowcaseKey: 'string',
    },
});
customElements.define(getWebComponentName('listing-carousel'), WebButton);
